export interface TransactionTypeConfig {
    label: string;
    color: string;
    requireTransferProducer: boolean;            // Colonne "TO PROD"
    requireTransferOperatorFromEscrow: boolean;   // Colonne "TO OPER" (Tableau 1)
    requireTransferOperatorFromProducer: boolean; // Colonne "TO OPER" (Tableau 2)
    pLabel: string;                               // Label Doc Producer
    oLabel: string;                               // Label Doc Operator
    pField: string | null;                        // Formule Doc Producer
    oField: string | null;                        // Formule Doc Operator
}

export const TRANSACTION_TYPES_CONFIG: Record<string, TransactionTypeConfig> = {
    PAYMENT: {
        label: 'Payment',
        color: '#2e7d32',
        requireTransferProducer: true,
        requireTransferOperatorFromEscrow: true,
        requireTransferOperatorFromProducer: false,
        pLabel: 'Escrow → Producer Wallet',
        pField: 'producer_part',
        oLabel: 'Escrow → Operator Wallet (SC)',
        oField: 'operator_part + vat'
    },
    REFUND: {
        label: 'Refund',
        color: '#ed6c02',
        requireTransferProducer: false,
        requireTransferOperatorFromEscrow: false,
        requireTransferOperatorFromProducer: true,
        pLabel: 'No transfer',
        pField: null,
        oLabel: 'Producer Wallet → Operator Wallet (SC)',
        oField: 'producer_part'
    },
    FEE: {
        label: 'Fee',
        color: '#0288d1',
        requireTransferProducer: false,
        requireTransferOperatorFromEscrow: false,
        requireTransferOperatorFromProducer: true,
        pLabel: 'No transfer',
        pField: null,
        oLabel: 'Producer Wallet → Operator Wallet (SC)',
        oField: 'operator_part + vat'
    },
    PAYMENT_COLLECTED_BY_SELLER: {
        label: 'Payment (COD)',
        color: '#455a64',
        requireTransferProducer: false,
        requireTransferOperatorFromEscrow: false,
        requireTransferOperatorFromProducer: true,
        pLabel: 'No transfer',
        pField: null,
        oLabel: 'Producer Wallet → Operator Wallet (SC)',
        oField: 'operator_part + vat'
    },
    REFUND_DELIVERED_BY_SELLER: {
        label: 'Refund (COD)',
        color: '#7b1fa2',
        requireTransferProducer: true,
        requireTransferOperatorFromEscrow: false,
        requireTransferOperatorFromProducer: false,
        pLabel: 'Escrow → Producer Wallet',
        pField: 'operator_part + vat',
        oLabel: 'No transfer',
        oField: null
    },
    CREDIT_NOTE: {
        label: 'Credit Note',
        color: '#fbc02d',
        requireTransferProducer: true,
        requireTransferOperatorFromEscrow: false,
        requireTransferOperatorFromProducer: false,
        pLabel: 'Escrow → Producer Wallet',
        pField: 'producer_part',
        oLabel: 'No transfer',
        oField: null
    }
};

export const getCfg = (type: string): TransactionTypeConfig => 
    TRANSACTION_TYPES_CONFIG[type] || {
        label: type,
        color: '#9e9e9e',
        requireTransferProducer: false,
        requireTransferOperatorFromEscrow: false,
        requireTransferOperatorFromProducer: false,
        pLabel: 'Unknown',
        pField: null,
        oLabel: 'Unknown',
        oField: null
    };